import { LinkElement } from '@swagger-api/apidom-ns-openapi-3-0';
class Link extends LinkElement {}
export default Link;